import { Helmet } from 'react-helmet';

export const PlausibleAnalytics = () => {
  return (
    <Helmet>
      <script defer data-domain="compensation.app" src="https://plausible.io/js/script.js"></script>
    </Helmet>
  );
};
